__turbopack_context__.v({
  "card": "IntroBlock-module__m9J-CW__card",
  "imageWrapper": "IntroBlock-module__m9J-CW__imageWrapper",
  "introWrapper": "IntroBlock-module__m9J-CW__introWrapper",
  "subtitleWrapper": "IntroBlock-module__m9J-CW__subtitleWrapper",
  "textContainer": "IntroBlock-module__m9J-CW__textContainer",
  "titleWrapper": "IntroBlock-module__m9J-CW__titleWrapper",
});
